import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";

export default function ConfirmDialog({
    open,
    onClose,
    onConfirm,
    title,
    body,
    confirmLabel,
    confirmClassName = "btn btn--primary ml-2",
}) {
    return (
        <Dialog open={open} handler={onClose} className="dialog">
            <DialogHeader className="dialog__header">
                {title}
            </DialogHeader>
            <DialogBody className="dialog__body">
                {body}
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    variant="filled"
                    className="btn btn--secondary"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    variant="filled"
                    className={confirmClassName}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
